import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.916 6q1.446 0 2.275 1.056t.829 2.145q0 .715-.732.715-.665 0-.845-.845-.34-1.608-1.608-1.609-2.243 0-2.243 5.054 0 4.76 2.21 4.76 1.252 0 1.804-1.982.21-.763.861-.763.747 0 .748.731 0 .715-.634 1.901-.844 1.576-2.73 1.576-3.85 0-3.851-6.304Q0 6 3.916 6M11.927 15.928l2.275-9.213Q14.38 6 14.966 6q.714 0 .714.666l-.032.244-2.697 10.903q-.244.942-1.024.943-.78 0-1.024-1.008L8.223 6.91l-.033-.244Q8.19 6 8.905 6q.553 0 .73.65zM20.246 15.928l2.275-9.213q.18-.715.764-.715Q24 6 24 6.666l-.032.244-2.698 10.903q-.243.942-1.024.943-.78 0-1.023-1.008L16.542 6.91l-.033-.244q0-.666.715-.666.552 0 .731.65z"
    }, null, -1)
  ]))]))
}
export default { render: render }